Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _constants = require('../../constants');

exports['default'] = _react.PropTypes.oneOf([_constants.START_DATE, _constants.END_DATE]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/shapes/FocusedInputShape.js
 ** module id = 1498
 ** module chunks = 0
 **/